// HireAra Color Palette
// Based on the brand colors from index.css

export const araColors = {
	// Primary brand colors
	blue: "#2fbad1",
	purple: "#5114fe",
	darkBlue: "#1e1751",
	lavender: "#ece7ff",

	// Neutrals - Dark theme
	neutralDark: {
		100: "#ffffff",
		80: "#cccccc",
		60: "#999999",
		40: "#666666",
		20: "#333333",
		5: "#0d0d0d",
	},

	// Neutrals - Light theme
	neutralLight: {
		100: "#000000",
		80: "#333333",
		60: "#666666",
		40: "#999999",
		20: "#cccccc",
		5: "#f2f2f2",
	},

	// Status colors
	success: "#219653",
	error: "#e30000",
	warning: "#daac1c",

	// Additional colors
	green: "#219653",
	lightGreen: "#b6ebd7",
	gold: "#daac1c",
	darkGold: "#755b0d",
	red: "#e30000",

	// Solid colors
	white: "#ffffff",
	black: "#000000",
} as const

// Semantic color mappings
export const semanticColors = {
	background: {
		primary: araColors.neutralDark[100],
		secondary: araColors.neutralLight[5],
	},
	text: {
		primary: araColors.neutralDark[5],
		secondary: araColors.neutralDark[20],
		brand: araColors.blue,
		white: araColors.white,
	},
	border: {
		primary: araColors.neutralLight[20],
		brand: araColors.blue,
	},
	input: {
		background: araColors.neutralDark[100],
		backgroundHover: araColors.neutralLight[5],
	},
} as const

// Mantine color arrays (10 shades from light to dark)
export const mantineColorShades = {
	araBlue: [
		"#e6f9fc",
		"#b3eef5",
		"#80e2ed",
		"#4dd7e6",
		"#2fbad1", // Main shade (index 5)
		"#2295a7",
		"#18707e",
		"#0e4b54",
		"#05262a",
		"#020f10",
	],
	araPurple: [
		"#f5f0ff",
		"#e6d9ff",
		"#cdb3ff",
		"#b38cff",
		"#9a66ff",
		"#5114fe", // Main shade (index 5)
		"#410fe5",
		"#310acb",
		"#2106b2",
		"#100398",
	],
	araDark: [
		"#f0eef7",
		"#d3cde8",
		"#b5abd9",
		"#9789ca",
		"#7a68bb",
		"#1e1751", // Main shade (index 5)
		"#181241",
		"#120e31",
		"#0c0920",
		"#060510",
	],
} as const

export type AraColors = typeof araColors
export type SemanticColors = typeof semanticColors
export type MantineColorShades = typeof mantineColorShades
